export default __webpack_public_path__ + "static/media/577.d52d7c5f.png";